import { render } from "./banner.vue?vue&type=template&id=545b6891&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"

import "./banner.vue?vue&type=style&index=0&id=545b6891&scoped=true&lang=css"
import "./banner.vue?vue&type=style&index=1&id=545b6891&lang=css"

import exportComponent from "D:\\project\\item\\jts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545b6891"]])

export default __exports__